export const ALERT_SHOW = "ALERT_SHOW";
export const ALERT_HIDE = "ALERT_HIDE";
export const ALERT_CLEAN = "ALERT_CLEAN"